// 封装购物车模块

import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useUserStore } from './userStore'
import { ElMessage } from 'element-plus'
import {goUp,goRate,exchangeRate,valueRange} from "@/utils/index"
import { insertCartAPI, findNewCartListAPI, delCartAPI } from '@/apis/cart'

export const useCartStore = defineStore('cart', () => {
    const order_no_list=ref([])//存储的是创建订单的订单号数组
    const userStore = useUserStore()
    const isLogin = computed(() => userStore.userInfo.token)
    // 1. 定义state - cartList
    const cartList = ref([])
    const checkoutList=ref([])
    const usdData=ref({})
    // const freight_fee=ref();
    const cartTotal=ref(0)
    const data=reactive({
        list:[]
    })
    const isPlaceAnOrder= ref([])//提交订单
    // 获取最新购物车列表action
    const updateNewList = async () => {
     
   
        const res = await findNewCartListAPI()
        console.log('购物车数据',cartList.value)
        if(res.code==0){
            if(res.data.list==null){
                cartList.value=[]
                checkoutList.value=[]
            }else{
                cartList.value = res.data.list
                checkoutList.value=res.data.list
            }
           
        }else{
            ElMessage({ type: 'error', message: res.message })
        }
       
        
    }
    // 2. 定义action - addCart
    //加入购物车
    const addCart = async (goods) => {
        // const { skuId, count } = goods
        if (isLogin.value) {
            // 登录之后的加入购车逻辑
            let data={
                // inventory:goods.inventory || 0,
                // shop_user_id:goods.shop_user_id,
                
                // needIntlPostage:goods.needIntlPostage,//需要国际邮费
               
                // from:goods.from, 
                // sku:goods.sku,
                // sku_info:goods.sku_info || null,
                product_id:goods.id,//商品id
                quantity:goods.num,//数量
                sku_id:goods.sku_info.sku_id,//skuid
                sku_name:goods.sku_info.properties_name,//sku名称
                source:goods.source,//商品来源
                edit:goods.edit
            }
           const res= await insertCartAPI(data)
           if(res.code==0){
            await updateNewList()
            allCheck(false);
            // ElMessage({ type: 'success', message: '加入购物车成功！' })
           }else{
            ElMessage({ type: 'error', message: res.message })
           }

            
        } else {
            // 添加购物车操作
            // 已添加过 - count + 1
            // 没有添加过 - 直接push
            // 思路: 通过匹配传递过来的商品对象中的skuId能不能在cartList中找到，找到了就是添加过
            console.log(goods)
            const item = cartList.value.find((item) => goods.id === item.id)
            console.log(item)
            if (item) {
                // 找到了
                item.count++
            } else {
                // 没找到
                cartList.value.push(goods)
            }
        }
    }

    // 删除购物车 -> 登录状态下
    const delCart = async (arr) => {
        
        if (isLogin.value) {
            // let ids=[]
            // if(skuId!=0){
            //     ids=[skuId]
            // }
            let data={list:arr}
            // 调用接口实现接口购物车中的删除功能
          const res=  await delCartAPI(data)
          if(res.code==0){
            updateNewList()
          }else{
            ElMessage({ type: 'error', message: res.message })
          }
           
        } else {
            // 思路：
            // 1. 找到要删除项的下标值 - splice
            // 2. 使用数组的过滤方法 - filter
            const idx = cartList.value.findIndex((item) => skuId === item.skuId)
            cartList.value.splice(idx, 1)
        }
    }

    // 清除购物车
    const clearCart = () => {
        cartList.value = []
    }


    // 单选功能
    const singleCheck = (userId,skuId,shopId, selected) => {
        
        data.list=cartList.value
        console.log('单选',data.list)
        cartList.value.forEach(user => {
            if(user.shop_user_id==shopId){
                user.list.forEach(item => {
                    if(userId==item.id){
                        if(skuId==item.sku_id){
                            // 给每个item添加selected属性，并设置为true
                            item.selected = selected;
                        }
                    }
                });
               let list=user.list.filter(item => item.inventory >0)
                console.log('list',list)
                const allSelected = list.every(item => item.selected === true);
                console.log('allSelected',allSelected)
                if(allSelected){
                    user.selected=true
                }else{
                    user.selected=false
                }
            }
        })
        checkoutList.value=cartList.value
        console.log('最后值--',cartList.value)
    }
    /**
     * 根据用户全选
     */
    const userAllCheck=(i,selected)=>{
        cartList.value.forEach(user => {
            if(user.shop_user_id==i){
                user.selected = selected
                user.list.forEach(item => {
                    if (item.inventory != 0 && item.status!=2) {
                        
                        // 给每个item添加selected属性，并设置为true
                        item.selected = selected;
                    }else{
                       
                        // 给每个item添加selected属性，并设置为true
                        item.selected = false;
                    }
                });
            }
        })
        checkoutList.value=cartList.value
    }

    // 全选功能
    const allCheck = (selected) => {
        console.log(selected)
      
        cartList.value.forEach(user => {
            user.selected = selected
            // 内层循环遍历每个用户的list
            user.list.forEach(item => {
                
                if(item.inventory>0 && item.status!=2){
                    // 给每个item添加selected属性，并设置为true
                    item.selected = selected;
                }else{
                    item.selected =false
                }
                console.log('pind--',item)
            });
        });
        checkoutList.value=cartList.value
       console.log(checkoutList.value)
    }
    // 计算属性
    // 1. 总的数量 所有项的num之和
    // const allCount = computed(() => cartList.value.reduce((a, c) => a + c.num, 0))
    
    const allCount = computed(() =>{
        let total=0
        cartList.value.forEach(user => {
            if(user.selected){
                user.list.forEach(item => {
                    if(item.selected){
                    // 累加每个商品的total_price
                    total += item.quantity;
                    }
                    
                });
            } else{
                user.list.forEach(item => {
                    if(item.selected){
                    // 累加每个商品的total_price
                     total += item.quantity;
                    }
                    
                });
            }
           
         });
         return total;
    })
    
  
    // 4. 已选择商品价格合计
    // const selectedPrice = computed(() => cartList.value.filter(item => item.selected).reduce((a, c) => a + c.num * c.price,0))
    const selectedPrice=computed(() =>{
        console.log('cartList.value',cartList.value)
        let total=0

        cartList.value.forEach(user => {
            if(user.selected){
                user.list.forEach(item => {
                    if(item.selected){
                    // 累加每个商品的total_price
                total +=  goRate(item.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate)*item.quantity ;
                    }
                    
                });
            }  else{
               
                user.list.forEach(item => {
                    if(item.selected){
                    // 累加每个商品的total_price
                   total += item.quantity * goRate(item.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate);
                    }
                    
                });
            }
            
        });
        return total
    })
    //导航购物车总和
    const menuAllCount=computed(() =>{
        let total=0
        cartList.value.forEach(user => {
            user.list.forEach(item => {
                total += item.quantity;
            });
        });
        return total;
    })
    const menuAllPrice=computed(() =>{
        let total=0
        cartList.value.forEach(user => {
            user.list.forEach(item => {
                // 累加每个商品的total_price
               total += item.quantity * goRate(item.price,userStore.exchangeRate.symbol, userStore.exchangeRate.rate);
            });
            
        });
        return total
    })
    //导航购物车数据
    // 2. 总价 所以项的num * price之和
    const allPrice = computed(() => cartList.value.reduce((a, c) => a + c.quantity * c.price, 0))

    // 3. 已选择数量
    const selectedCount = computed(() => cartList.value.filter(item => item.selected).reduce((a, c) => a + c.quantity, 0))
    
    
    // 是否全选
    const isAll = computed(() => cartList.value.every((item) => item.selected))


    return {
        cartList,
        allCount,
        allPrice,
        isAll,
        selectedCount,
        selectedPrice,
        menuAllCount,
        menuAllPrice,
        userAllCheck,
        clearCart,
        addCart,
        delCart,
        singleCheck,
        checkoutList,
        allCheck,
        updateNewList,
        usdData,
        order_no_list
    }
}, {
    persist: true,
})